<template>
<div class="page-in" style="">


  <!-- BARRA DI NAVIGAZIONE MY LOGIN -->
  <headbar></headbar>


   <div class="row pad-in " style="padding:20px 0;background:#E3EDF9;" >

      <div class="col s12 yo-text-xl yo-text-bold yo-spacing-s black" style="padding:0 50px;">EVENTI FAD</div>
      <div class="col s12 yo-text-n  yo-spacing-s black" style="padding:0 50px 50px 50px;">
         In questa sezione sono presenti tutti i corsi ai quali risulta iscritto.
         <br />
         Può recuperare informazioni in merito alla sua iscrizione (es. fattura) e procedere con la gestione per acquisire i crediti ECM.
      </div>

      <div class="col s12 mylogin-elenco-res">
         <evento v-for="item in eventi" :evento="item" :key="item.id" v-if="item.tipologiaformazione=='1'" class="medicina"></evento>
      </div>
   </div>


   <!-- SEZIONE INTERESSE O RANDOM 
   <eventiInteresse></eventiInteresse>
   -->
   <!-- SEZIONE AREE -->
   <aree></aree>

</div>
</template>

<script>
import headbar from '../components/Mylogin-headbar'
import evento from '../components/Mylogin-elenco-fad'
import eventiInteresse from '../components/Eventi-interesse'
import aree from '../components/Aree'

export default {
   name: 'home',
   components: {
      headbar,
      eventiInteresse,
      aree,
      evento
   },
   created () {
      this.$teras.page.title = "Mylogin Eventi Residenziali"
      this.$teras.page.sezione = "myLogin"
   },
   computed: {
      eventi: function () {
         var itemFilter = []
         for (let item of this.$contatto._evento){
            //if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1)
               itemFilter.push(item) 
         }
         return itemFilter
      }
   }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Mylogin-fad.vue